import React, { Suspense, useEffect, useState } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/index";
import VpnBlockedScreen from "./util/VpnBlockedScreen";
import { VPN_BLOCKED_EVENT } from "./service/ApiHelper";
// import { configureAmplify } from "./aws-exports-default";
const store = configureStore(/* provide initial state if any */);

const NextApp = () => {
  const [isVpnBlocked, setIsVpnBlocked] = useState(false);

  useEffect(() => {
    const handleVpnBlocked = () => {
      setIsVpnBlocked(true);
    };

    window.addEventListener(VPN_BLOCKED_EVENT, handleVpnBlocked);
    return () => {
      window.removeEventListener(VPN_BLOCKED_EVENT, handleVpnBlocked);
    };
  }, []);

  if (isVpnBlocked) {
    return <VpnBlockedScreen />;
  }

  return (
    // <ApolloProvider client={client}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </ConnectedRouter>
    </Provider>
    // </ApolloProvider>
  );
};
export default NextApp;
